import { Navigate } from "react-router-dom";
import { useContext } from "react";
import { HeyatYoluContext } from "./App";

export default function PrivateRoute({ children, allowedRoles }) {
  const { user } = useContext(HeyatYoluContext);

  // user yoxdursa → redirect
  if (!user) {
    return <Navigate to="/giris" replace />;
  }

  // rol yoxlanışı
  if (allowedRoles && !allowedRoles.includes(user.role)) {
    return <Navigate to="/unauthorized" replace />;
  }

  return children;
}
